import React from "react";

const OPTIONS = [
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "yearly", label: "Yearly" },
];

const ChartPeriodTabs = ({ value, onChange }) => (
  <div className="qx-period-tabs" role="tablist" aria-label="Chart period">
    {OPTIONS.map((opt) => (
      <button
        key={opt.value}
        type="button"
        role="tab"
        aria-selected={value === opt.value}
        className={`qx-period-tab${value === opt.value ? " is-active" : ""}`}
        onClick={() => onChange(opt.value)}
      >
        {opt.label}
      </button>
    ))}
  </div>
);

export default ChartPeriodTabs;
